<template>
  <Splide :options="options">
    <SplideSlide>
      <div class="item">
        <a href="/lotterie/mein-gluecks-los">
          <img src="../assets/images/mgl.jpg" alt="Glücks-Los bestellen">
        </a>
      </div>
    </SplideSlide>
    <SplideSlide>
      <div class="item">
        <a href="/lotterie/jahreslos">
          <img src="../assets/images/jl.jpg" alt="Jahreslos bestellen">
        </a>
      </div>
    </SplideSlide>
    <SplideSlide>
      <div class="item">
        <a href="/lotterie/5-sterne-los">
          <img src="../assets/images/fsl.jpg" alt="5 Sterne-Los bestellen">
        </a>
      </div>
    </SplideSlide>
  </Splide>
</template>

<script>
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import { defineComponent } from 'vue';

export default defineComponent({
  components: {
    Splide,
    SplideSlide
  },
  setup() {
    const options = {
      type: 'loop',
      padding: { right: '20%' },
      perPage: 2,
      perMove: 1,
      i18n: {
        next: 'Zum nächsten Slide',
        prev: 'Zum vorherigen Slide',
        first: 'Zum ersten Slide',
        last: 'Zum letzten Slide',
        slideX: 'Gehe zur %s. Slide',
        pageX: 'Gehe zur %s. Seite',
        play: 'Starte den Autoplay',
        pause: 'Pausiere den Autoplay',
        select: 'Wähle einen Slide zum anzeigen',
        slideLabel: 'Slide %s von %s'
      },
      breakpoints: {
        594: {
          perPage: 1,
        },
      }
    };

    return { options };
  },
  methods: {
  },
});
</script>

<style lang="scss">
@import "@splidejs/vue-splide/css/core";

.splide {
  position: relative;

  img {
    width: 100%;
  }

  &__track {
    position: relative;
    margin-right: -32px;
  }

  .item {
    width: 100%;
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    color: var(--vc-clr-white);
    
    a:focus-visible, a:focus {
      outline: 0.125rem solid #fff !important;
      outline-offset: 0.125rem;
      -webkit-box-shadow: 0 0 0 0.125rem #0060cc;
      box-shadow: 0 0 0 0.125rem #0060cc;
    }
  }  
}

.splide__arrows {
  width: 100%;
  bottom: 0;
  display: flex;
  position: absolute;
  justify-content: space-between;

  button.splide__arrow {
    height: 32px;
    width: 32px;
    display: flex;
    border-radius: 50%;
    color: #707070;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    background: transparent;
    border: 2px solid #707070;

    svg {
      display: none;
    }

    &:after {
      content: "\f198";
      font-family: "icons-webfont";
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      font-weight: bold;
      width: 32px;
      height: 32px;
      line-height: 32px;
    }

    &--next:after {
      content: "\f19a";
    }
  }
}

.splide__pagination {
  margin-top: 24px;

  li {
    height: 32px;
    padding: 0 11px;
    display: flex;
    align-items: center;
  }

  &__page {
    width: 8px !important;
    height: 8px;
    padding: 0;
    border-radius: 50%;
    border: 2px solid #707070;
    box-sizing: border-box;
    background: transparent;
    cursor: pointer;

    &.is-active {
      background: var(--color-red);
      border: none;
    }
  }
}

.splide__slide:not(.is-active) .item {
  transform: scale(0.94) translateY(5px) translateX(5px);
  transition: 0.3s;
}
</style>